import { render, staticRenderFns } from "./NotificationAudienceTargeting.vue?vue&type=template&id=2e4c2a30&scoped=true&"
import script from "./NotificationAudienceTargeting.vue?vue&type=script&lang=js&"
export * from "./NotificationAudienceTargeting.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAudienceTargeting.vue?vue&type=style&index=0&id=2e4c2a30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c2a30",
  null
  
)

export default component.exports